var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 1.483h-.917v-.65a.5.5 0 00-1 0v.65H4.008v-.65a.5.5 0 10-1 0v.65h-.741a2.092 2.092 0 00-2.1 2.084V11.9a1.916 1.916 0 001.916 1.917H10.6a1.925 1.925 0 001.925-1.917V3.392A1.925 1.925 0 0010.6 1.483zm.925 10.442a.924.924 0 01-.925.908H2.083a.917.917 0 01-.917-.916V4.958h9.1a.5.5 0 000-1h-9.1v-.391a1.092 1.092 0 011.1-1.092h.75v.408a.5.5 0 001 0v-.408H8.7v.408a.5.5 0 001 0v-.408h.9a.925.925 0 01.925.917v8.533z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.233 6.7h-1.75a.417.417 0 00-.417.417v.858c0 .23.187.417.417.417h1.75c.23 0 .417-.187.417-.417v-.858a.417.417 0 00-.417-.417z",
    fill: "#C4C4C4"
  })));
}
export default SvgDateCalendar;